var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 38,
    viewBox: "0 0 27 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 38V36.1C2.755 36.1 1.86042 35.7279 1.11625 34.9837C0.372083 34.2396 0 33.345 0 32.3V11.4C0 10.355 0.372083 9.46042 1.11625 8.71625C1.86042 7.97208 2.755 7.6 3.8 7.6H7.6V1.9C7.6 1.36167 7.78208 0.910417 8.14625 0.54625C8.51042 0.182083 8.96167 0 9.5 0H17.1C17.6383 0 18.0896 0.182083 18.4538 0.54625C18.8179 0.910417 19 1.36167 19 1.9V7.6H22.8C23.845 7.6 24.7396 7.97208 25.4838 8.71625C26.2279 9.46042 26.6 10.355 26.6 11.4V32.3C26.6 33.345 26.2279 34.2396 25.4838 34.9837C24.7396 35.7279 23.845 36.1 22.8 36.1V38H19V36.1H7.6V38H3.8ZM11.4 7.6H15.2V3.8H11.4V7.6ZM13.3 19C14.9783 19 16.6171 18.7862 18.2163 18.3587C19.8154 17.9312 21.3433 17.29 22.8 16.435V11.4H3.8V16.435C5.25667 17.29 6.78458 17.9312 8.38375 18.3587C9.98292 18.7862 11.6217 19 13.3 19ZM11.4 24.7V22.705C10.07 22.5467 8.77167 22.3092 7.505 21.9925C6.23833 21.6758 5.00333 21.2483 3.8 20.71V32.3H22.8V20.71C21.5967 21.2483 20.3617 21.6758 19.095 21.9925C17.8283 22.3092 16.53 22.5467 15.2 22.705V24.7H11.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weightIcon.da824e59bd0e73123b952eed9bc9b08e.svg";
export { ForwardRef as ReactComponent };